import { Route, useLocation, Navigate } from "react-router-dom";
import AdminAuthPage from "./components/account/AdminAuthPage";
import AdminDashBoardPage from "./components/adminDashboard/AdminBoard";
import ProjectPage from "./components/adminDashboard/project";

import AdminLayout from "./AdminLayout";

const AdminProtectedRoute = ({ children }) => {
  const token = localStorage.getItem("jwtToken");
  const isAdmin = localStorage.getItem("admin");
  const location = useLocation();

  if (!token || !isAdmin) {
    return (
      <Navigate
        to={`/admin-login?redirect=${encodeURIComponent(location.pathname)}`}
      />
    );
  }

  return children;
};

const AdminRoutes = () => [
  <Route path="/admin-login" element={<AdminAuthPage />} />,

  <Route path="/admindashboard" element={<AdminLayout />}>
    {/* Admin Route */}

    <Route
      path="/admindashboard/project/:id"
      element={
        <AdminProtectedRoute>
          <ProjectPage />
        </AdminProtectedRoute>
      }
    />
    <Route
      path="/admindashboard"
      element={
        <AdminProtectedRoute>
          <AdminDashBoardPage />
        </AdminProtectedRoute>
      }
    />
    {/* Admin Route */}
  </Route>,
];

export default AdminRoutes;
